import SimpleLightbox from 'simplelightbox'


const $images = $('.main-content a').filter(function () {
    // @ts-ignore
    return $(this).attr('href').match(/\.(png|jpg|jpeg|gif|webp)((\?.*)$|$)/i);
})

if ($images.length) {
    new SimpleLightbox($images.get(), {
        alertErrorMessage: 'Изображение не найдено',
        uniqueImages: false
    });
}

